import DashboardIcon from '@mui/icons-material/SpaceDashboard';
import SchoolIcon from '@mui/icons-material/School';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { Outlet } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';

import EventIcon from '@mui/icons-material/Event';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BarChartIcon from '@mui/icons-material/BarChart';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const navItems = [
  { label: 'Головна', path: '/admin', icon: <DashboardIcon /> },
  { label: 'Репетитори', path: '/admin/tutors', icon: <SchoolIcon /> },
  { label: 'Батьки', path: '/admin/parents', icon: <FamilyRestroomIcon /> },
  { label: 'Учні', path: '/admin/students', icon: <PeopleOutlineIcon /> },
  { label: 'Розклад', path: '/admin/schedule', icon: <EventIcon /> },
  { label: 'Бухгалтерія', path: '/admin/accounting', icon: <MonetizationOnIcon /> },
  { label: 'Звіт: репетитори', path: '/admin/reports', icon: <AssessmentIcon /> },
  { label: 'Звіт: учні', path: '/admin/reports-students', icon: <BarChartIcon /> },
];

const AdminLayout = () => (
  <DashboardLayout navItems={navItems}>
    <Outlet />
  </DashboardLayout>
);

export default AdminLayout;

